import { UserProfile } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { tokens } from '../../../ad/theme';

// Personal account settings (MIS-815 / Task 34). Clerk's self-contained
// <UserProfile /> owns the entire identity lifecycle (email/phone, password,
// 2FA, sessions, connected accounts); we only provide the page heading +
// container. Gated by _authenticated.tsx's beforeLoad sign-in check.
export const Route = createFileRoute('/_authenticated/settings/profile')({
  component: ProfileSettingsPage,
});

function ProfileSettingsPage() {
  // The embedded <UserProfile /> is themed via the ClerkProvider appearance
  // cascade (clerk-appearance.ts); the page heading uses the dark fg0 token so
  // it sits on the dark shell instead of stock light-mode gray.
  return (
    <div className="p-8">
      <h1 className="mb-6 text-2xl font-semibold" style={{ color: tokens.color.fg0 }}>
        Profile Settings
      </h1>
      <UserProfile />
    </div>
  );
}
